import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";

export class TaxLinesBus extends BaseBus
{
    constructor(data: TaxLinesBus = null) {
        super(data);
    }
    CID() {
        return this.taxLineId;
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!CommonFunctions.hasGuidValue(this.insertUserid)) {
            this.insertDt = date;
            this.insertUserid = userId;
            this.companyId = companyId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }

    taxLineId: any;
    companyId: any;
    taxCodeId: any;
    isActive: boolean;
    rate: number;
    taxLineName: string;
    supplierId: any;
    isTaxLabor: boolean;
    isTaxMaterial: boolean;
    isTaxOther: boolean;
    taxCodeTaxLineXREFId: any;
    supplierName: string;
    insertDt: Date;
    insertUserid: any;
    updateDt: Date;
    updateUserId: any;
    qbid: string;
    qbeditSequenceId: string;
}
